import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import { StepperCriteres, Pagination } from '../../components';


// material component
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import { Paper } from '@material-ui/core';
import { connect } from 'react-redux';
import { SET_REFERENTIEL } from '../../state/action/action';

const searchKeyFunction = (array, pos) => {
	let val;
	array.forEach((object) => {
		if (object.pos == pos) {
			return val = object ;
		}
	});
	return val;
}

const determinesNotes = (domaineObject) => {
	let copyDomaineObject = JSON.parse(JSON.stringify(domaineObject));
		//console.log(domaineObject)
	
	let domaineNote = 0;
	copyDomaineObject.domaine.referentiel.forEach(rel => {
		//console.log(`rel: ${rel.pos}`);
		let relNote = 0;
		rel.references.forEach(ref => {
			//console.log(`ref: ${ref.pos}`)
			let refNote = 0;
			ref.criteres.forEach(cr => {
				//console.log(`cr: ${cr.pos} + cr_ss: ${cr.sous_criteres.length}`)
				let ssCritere = cr.sous_criteres.length;
				let ouiNote = 0;
				cr.sous_criteres.forEach(ssCritere => {
					ouiNote = ssCritere.note === 1 ? ouiNote += 1 : ouiNote;
				});
				cr.note = critereRealNote(ssCritere, ouiNote);
				refNote += cr.note;				
			});
			ref.note = refNote;
			relNote += refNote;
		});		
		rel.note = relNote;
		domaineNote += relNote;
	});		
	copyDomaineObject.domaine.note = domaineNote;

	//console.log(`${copyDomaineObject.domaine.referentiel}`)

	return copyDomaineObject
}

const critereRealNote = (size, value) => {
	let percentage = value/size;
	if ( percentage >= 0.9 ) return 1;
	else if ( percentage >= 0.5 && percentage < 0.9 ) return 0.5;
	else if ( percentage < 0.5 ) return 0;
}

const Domaine = ({referentiel, dispatch, match}) => {
	// document data state management
	const [domaineCurrent, setDomaineCurrent] = useState(referentiel);
	const [referentielCurrent, setReferentielCurrent] = useState()
	const [referenceCurrent, setReferenceCurrent] = useState()
	const [critereCurrent, setCritereCurrent] = useState()
	const [sousCritereCurrent, setSousCritereCurrent] = useState()
	const [radioValue, setRadioValue] = useState('0');
	//const [comment, setComment] = useState("");
	const [stepActive, setStepActive] = useState(0);

	// lifecycles
	useEffect(() => {
		console.log("starts")
		//console.log(domaineCurrent.domaine)
		updateDomaineSubFields(domaineCurrent);
		//setStepActive(0);
	}, [match, domaineCurrent])

	useEffect(() => {
		setStepActive(0);
	}, [match])

	useEffect(() => {
		//console.log("Medium")
		
		let val = determinesNotes(domaineCurrent);
		setDomaineCurrent(val)/* (determinesNotes(domaineCurrent)) */;
		updateDomaineSubFields(val)
		setReferentiel(val)
	}, [radioValue])

	useEffect(() => {
	//console.log("Update")
		//setReferentiel(domaineCurrent)
	})

	// update function
	const updateDomaineSubFields = (domaineCurrent) => {
		let relCurrent = searchKeyFunction(domaineCurrent.domaine.referentiel, match.params.rel);
		let refCurrent = searchKeyFunction(relCurrent.references, match.params.ref);
		//console.log(refCurrent)
		let crCurrent = searchKeyFunction(refCurrent.criteres, match.params.cr);
		//console.log(match.params)
		let ssCurrent = crCurrent.sous_criteres;
		setReferentielCurrent(relCurrent);
		setReferenceCurrent(refCurrent)
		setCritereCurrent(crCurrent)
		setSousCritereCurrent(ssCurrent)
	}
	
	
	const setReferentiel = (value) => {
			const action = {
				type: SET_REFERENTIEL,
				value
			};
			dispatch(action)
	}

	// event and functions to work
	const handleSousCritereCurrent = (value, pos, type) => {
		let prevSousCriteres = sousCritereCurrent;

		switch (type) {
			case "radio": {
				setRadioValue(value)
				
				prevSousCriteres[pos].note = parseInt(value);
				setSousCritereCurrent(prevSousCriteres);
				return ;
			}
			
			/* case "comment": {
				setComment(value)
				prevSousCriteres[pos].observation = value;
				setSousCritereCurrent(prevSousCriteres);
				return ;
			} */

			default:
				break;
		}	
	}
	const classes = useStyles();

  return (
	<Grid item container className={classes.root} direction='column' alignItems='center' justify='space-around' xs={12} sm={6}>
	
		{ sousCritereCurrent && <> 
		<Grid item container className={classes.title} direction='row' alignItems='center' justify='center' >
				<Paper className={[classes.firstPart, classes.domaineStyle]}>
			<Grid item >
				<Box component='p' className={classes.typography} ><Box component='span' className={classes.typeBox}>Domaine {domaineCurrent.domaine.pos}:</Box> {domaineCurrent.domaine.titre}</Box>
			</Grid>
				</Paper>
			{/* <Grid item alignItems='center' justify='center' container className={classes.secondPart}>
				 <Box component='p'>{domaineCurrent.note}</Box> 
			</Grid> */}
		</Grid>
		
		<Grid item container className={classes.title} direction='row' alignItems='center' justify='center' >
			<Paper className={[classes.firstPart, classes.referentielStyle]}>
			<Grid item >
				<Box component='p' className={classes.typography}><Box component='span'>Référentiel {referentielCurrent.pos}:</Box> {referentielCurrent.titre}</Box>
			</Grid>
			</Paper>
			{/* <Grid item className={classes.secondPart} alignItems='center' justify='center' container>
				<Box component='p'>{referentielCurrent.note}</Box>
			</Grid> */}
		</Grid>
		
		<Grid item container className={classes.title} direction='row' alignItems='center' justify='center' >
			<Paper className={[classes.firstPart, classes.referenceStyle]}>
			<Grid item >
				<Box component='p' className={classes.typography}><Box component='span'>Référence {referenceCurrent.pos}:</Box> {referenceCurrent.titre}</Box>
			</Grid>
			</Paper>
			{/* <Grid item className={classes.secondPart} alignItems='center' justify='center' container>
				<Box component='p'>{referenceCurrent.note}</Box>
			</Grid> */}
		</Grid>
		
		<Grid item container className={classes.title} direction='row' alignItems='center' justify='center' >
			<Paper className={[classes.firstPart, classes.critereStyle]}>
			<Grid item >
				<Box component='p' className={classes.typography}><Box component='span'>Critères {critereCurrent.pos}:</Box> {critereCurrent.titre}</Box>
			</Grid>
			</Paper>
			{/* <Grid item className={classes.secondPart} alignItems='center' justify='center' container>
				<Box component='p'>{critereCurrent.note}</Box>
			</Grid> */}
		</Grid>

		<StepperCriteres 
			sousCriteres={sousCritereCurrent}
			handleSousCritereCurrent={handleSousCritereCurrent} 
			radioValue={radioValue} 
			/* commentChange={comment} */
			activeStep={stepActive}
			setActiveStep ={setStepActive}
			/* stepActive={stepActive} 
			setStepActive={setStepActive} */
			/>
		
		<Pagination data={referentiel} params={match.params} />
		</>}
		
		<Link to='/resultats' style={{ textDecoration: 'none', color: 'inherit', marginTop: '5%', marginBottom: '15%' }}>
			<Button variant="outlined" color="secondary"  className={classes.btn}>
				Voir les résultats
			</Button>
		</Link>

	</Grid>
	)
}


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
		paddingLeft: '2%',
		paddingRight: '2%',
  },
	title: {
		marginBottom: 5,
	},
	typography: {
		fontSize: 14
	},
	firstPart: {
		width: '80%',
		backgroundColor: 'white',/* '#e8ebea' */
		paddingLeft: theme.spacing(1),
		//borderRadius: 10,
		borderLeftWidth: theme.spacing(0.5),
		borderLeftStyle: 'solid',
	},
	secondPart: {
		width: '10%',
		borderRadius: 10,
		backgroundColor: theme.palette.background.default,
		color: theme.palette.primary.main
	},
	domaineStyle: {
		borderLeftColor: theme.palette.success.main,/* '#5ab87a', */
		'& span':{
			fontWeight: 'bold',
			color: theme.palette.success.main,
		}
	},
	referentielStyle: {
		borderLeftColor: theme.palette.secondary.main,/* '#e65a55', */
		'& span':{
			fontWeight: 'bold',
			color:  theme.palette.secondary.main
		}
	},
	referenceStyle: {
		borderLeftColor: theme.palette.primary.main,/* '#5f82cf', */
		'& span':{
			fontWeight: 'bold',
			color: theme.palette.primary.main
		}
	},
	critereStyle: {
		borderLeftColor: theme.palette.warning.main,/* '#bacf5f' */
		'& span':{
			fontWeight: 'bold',
			color:  theme.palette.warning.main
		}
	},
	btn: {
      '& .MuiButton-label' :{
          textTransform :'none'
      }
  }

}));

const mapStateToProps = (state) => {
	return {
		referentiel: state.setReferentielReducer.referentiel
	}
}

export default connect(mapStateToProps)(Domaine);
